import { useQuery } from "@tanstack/react-query";
import { endpoints } from "../endpoints";
import { getResource } from "../https";
import { Addresses } from "../types";
import { querykeys } from "../querykeys";

interface AddressResponse {
  data: Addresses[];
}

export const getAddresses = async (): Promise<AddressResponse> => {
  return await getResource({
    pathUrl: `${endpoints.addresses}`,
  });
};

export const useGetAddresses = () => {
  const query = useQuery({
    queryKey: [querykeys.GET_ADDRESSES],
    queryFn: () => getAddresses(),
  });
  return query;
};
